import React from 'react';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import stringHelper from '../../Helpers/stringHelper';
import urlHelper from '../../Helpers/urlHelper';
import LongText from '../../Elements/LongText';

export default class LineItemCreditRequestItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    this.ApolloId = item.apolloId;
    this.LineItemCreditId = item.lineItemCreditId;
    this.Name = item.name;
    this.InitDue = item.initDue;
    this.Paid = item.paid;
    this.CurrencySymbol = item.currencySymbol;
    this.InitialTotalFormatted = stringHelper.getValueWithSymbol('', this.CurrencySymbol, this.InitDue);
    this.CreditAmountVat = item.creditAmountVat;
    this.CreditAmountVatFormatted = stringHelper.getValueWithSymbol('', this.CurrencySymbol, this.CreditAmountVat);
    this.Type = item.type;
    this.LineItemId = item.lineItemId;
    this.CreditAmountVatreimb = item.creditAmountVatreimb;
    this.CreditAmountVatreimbFormatted = stringHelper.getValueWithSymbol(
      '',
      this.CurrencySymbol,
      this.CreditAmountVatreimb
    );
    this.CreditAmount = item.creditAmount;
    this.CreditAmountFormatted = stringHelper.getValueWithSymbol('', this.CurrencySymbol, this.CreditAmount);
    this.CreditAmountReimb = item.creditAmountReimb;
    this.CreditAmountReimbFormatted = stringHelper.getValueWithSymbol('', this.CurrencySymbol, this.CreditAmountReimb);
    this.CreditMemoRequestId = item.creditMemoRequestId;
    this.Selected = false;
    this.Fee = item.fee;
    this.Reimbursement = item.reimbursement;
    this.Outstanding = item.outstanding;
    this.OutstandingFormatted = stringHelper.getValueWithSymbol('', this.CurrencySymbol, this.Outstanding);
  }

  static NameOfTheIdField() {
    return 'CreditMemoRequestId';
  }
  static nameOfTheItemDetailList() {
    return 'Credit Memo';
  }
  static MoneyFields = ['InitDue', 'Paid'];
  static Currency() {
    return 'CurrencySymbol';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }
  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [{ label: 'BARE #', name: 'CreditMemoRequestId', className: 'text-left' }],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: LineItemCreditRequestItem.getSelectedCellHeader,
        orderById: '',
        data: LineItemCreditRequestItem.getSelectedCellContent,
        className: 'text-center',
        minWidth: 20,
      },
      { label: 'Line Credit ID', orderById: 'LineItemCreditId', data: 'LineItemCreditId' },
      { label: 'Apollo ID', orderById: 'ApolloId', data: LineItemCreditRequestItem.GetDetailCellContent },
      {
        label: 'Location',
        orderById: 'Name',
        data: (item) => (
          <LongText
            text={item.Name}
            maxLength={100}
          />
        ),
      },
      { label: 'Fee Credit', orderById: 'CreditAmount', data: 'CreditAmountFormatted' },
      { label: 'Reimb. Credit', orderById: 'CreditAmountReimb', data: 'CreditAmountReimbFormatted', minWidth: 90 },
      { label: 'Fee Tax Credit', orderById: 'CreditAmountVat', data: 'CreditAmountVatFormatted' },
      {
        label: 'Reimb. Tax Credit',
        orderById: 'CreditAmountVatreimb',
        data: 'CreditAmountVatreimbFormatted',
        minWidth: 105,
      },
      { label: 'Initial Total', orderById: 'InitDue', data: 'InitialTotalFormatted' },
      {
        label: 'Outstanding',
        orderById: 'Outstanding',
        data: 'OutstandingFormatted',
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Type', orderById: 'Type', data: 'Type' },
      { label: 'Line Item ID', orderById: 'LineItemId', data: LineItemCreditRequestItem.GetLineItemDetailCellContent },
      // M: 2023-04-13: CD-2942: Commented out because it is not used currently, but the feature is available in Caspian,
      // so we can uncomment it if we need it in the future.
      // { label: " ", orderById: "", data: LineItemCreditRequestItem.getActionsContent, type: FieldTypesEnum.ActionButton, className: "text-center" },
    ];
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={LineItemCreditRequestItem.selectedStatus()}
          onChange={(e) => {
            LineItemCreditRequestItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            LineItemCreditRequestItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ApolloId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'assignments/search',
      `AsSassieAsgnId=${item.ApolloId}`,
      'Open up in a new tab'
    );
  }

  static GetLineItemDetailCellContent(item) {
    if (item.Type !== 'LineItem') {
      return <div>{item.LineItemId}</div>;
    }
    return urlHelper.getIconLinkComponentFigma(
      item.LineItemId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'clientlineitemdetails',
      `id=${item.LineItemId}`,
      'Open up in a new tab'
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            onClick: () => LineItemCreditRequestItem.editFunction(item.ApolloId, item),
            iconName: 'fa-solid fa-edit',
            roleKey: 'creditmemo_editfaicon',
          },
        ]}
      />
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };
}
